import Widget from "./Widget";

class Widgets {
  constructor(private readonly _list: Widget[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public has(index: number): boolean {
    return !!this._list[index];
  }

  public toList(): Widget[] {
    return this._list;
  }

  public findByIndex(index: number): Widget {
    if (this.isEmpty() || !this.has(index)) return new Widget();
    return this._list[index];
  }

  public replace(index: number, widget: Widget): Widgets {
    if (this.isEmpty() || !this.has(index)) return new Widgets();
    this._list[index] = widget;
    console.warn(this._list);
    return new Widgets(this._list);
  }

  public add(widget: Widget): Widgets {
    this._list.push(widget);
    return new Widgets(this._list);
  }

  public delete(index: number): Widgets {
    if (this.isEmpty() || !this.has(index)) return new Widgets(this._list);
    this._list.splice(index, 1);
    return new Widgets(this._list);
  }

  public size(): number {
    return this._list.length;
  }
}

export default Widgets;
